export default __webpack_public_path__ + "static/media/landing-lg.42ac0933.webp";